import { render, staticRenderFns } from "./TradingSimulatorForm.vue?vue&type=template&id=e52a25ba&scoped=true&"
import script from "./TradingSimulatorForm.vue?vue&type=script&lang=js&"
export * from "./TradingSimulatorForm.vue?vue&type=script&lang=js&"
import style0 from "./TradingSimulatorForm.vue?vue&type=style&index=0&id=e52a25ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52a25ba",
  null
  
)

export default component.exports